import { apiFetch } from "../helper/apiClient";

export async function getOrderHistory() {
    try {
        const response = await apiFetch('user/orders/get', {
            method: 'GET',
        },
        { auth: true });

        const responseBody = await response.json();
        return responseBody;
    } catch (error) {
        console.error(error);
    }
}

export async function sendPasswordResetLink(email) {
    const response = await apiFetch('user/password/forgot', {
        method: 'POST',
        body: JSON.stringify({
            'email': email
        })
    });

    const responseBody = await response.json().catch(() => ({}));
    if (!response.ok) {
        throw new Error(responseBody?.detail || responseBody?.message || 'Failed to send reset link');
    }
    return responseBody;
}

export async function resetPassword(password, uid, token) {
    try {
        const response = await apiFetch('user/password/reset', {
            method: 'POST',
            body: JSON.stringify({
                'password': password,
                'uid': uid,
                'token': token
            })
        });
        
        const responseBody = await response.json();
    } catch (error) {
        console.error(error);
    }

}

export async function getCoupons() {
    try {
        const response = await apiFetch('coupon/apply', {
            method: 'GET',
        }, { auth: true });
        
        const responseBody = await response.json();
        if (!response.ok) {
            throw new Error(responseBody?.detail || 'Failed to load coupons');
        }
        return responseBody;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export async function getCollections(userId) {
    try {
        const response = await apiFetch(`collection/collections?userId=${userId}`, {
            method: 'GET'},
            { auth: true }
      );
        
        const responseBody = await response.json();
        console.log(responseBody);
        return responseBody;
    } catch (error) {
        console.error(error);
    }
}


export async function getMyCollection() {
    try {
        const response = await apiFetch(`collection/collections`, {
            method: 'GET'},
            { auth: true }
      );
        
        const responseBody = await response.json();
        console.log(responseBody);
        return responseBody;
    } catch (error) {
        console.error(error);
    }
}

export async function addCollection(collectionName) {
        try {
        const response = await apiFetch(`collection/collections`, {
            method: 'POST',
            body: JSON.stringify({collection_name: collectionName})
        });
        
        return response.status;
    } catch (error) {
        console.error(error);
    }
}

export async function getUserDetails() {
  const res = await apiFetch(
    "user/data/get",
    { method: "GET" },
    { auth: true } // must send access token
  );

  let body = {};
  try { body = await res.json(); } catch {}

  if (!res.ok) {
    throw new Error(body?.detail || `Failed to load user details (${res.status})`);
  }

  // body shape:
  // { firstName, lastName, tiktokName, email, address: null | { ... } }
  return body;
}

export async function upsertAddress(addressPayload) {
  // addressPayload must include: address, city, postcode, state, country
  const res = await apiFetch(
    "user/data/get",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(addressPayload),
    },
    { auth: true }
  );

  let body = {};
  try { body = await res.json(); } catch {}

  if (!res.ok) {
    const fieldErrors = body?.errors;
    if (fieldErrors && typeof fieldErrors === "object") {
      const first = Object.values(fieldErrors).flat()[0];
      throw new Error(
        typeof first === "string" ? first : body?.detail || `Failed to save address (${res.status})`
      );
    }
    throw new Error(body?.detail || `Failed to save address (${res.status})`);
  }

  // body: { message: "Address created successfully" } or "updated..."
  return body;
}

export async function updateProfile(profilePayload) {
  const res = await apiFetch(
    "user/data/get",
    {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(profilePayload),
    },
    { auth: true }
  );

  let body = {};
  try { body = await res.json(); } catch {}

  if (!res.ok) {
    throw new Error(body?.detail || `Failed to update profile (${res.status})`);
  }

  return body;
}

export async function getWishlist({ userId = null, username = null } = {}) {
  const params = new URLSearchParams();

  if (userId != null) params.set("user_id", String(userId));
  if (username) params.set("username", String(username));

  const url =
    params.toString().length > 0
      ? `collection/wishlist?${params.toString()}`
      : `collection/wishlist`;

  const res = await apiFetch(url, { method: "GET" }, { auth: true });

  let body = {};
  try { body = await res.json(); } catch {}

  if (!res.ok) {
    throw new Error(body?.detail || `Failed to retrieve wishlist (${res.status})`);
  }

  return body.items || [];
}


export async function addToWishlist(productId) {
  const res = await apiFetch(
    "collection/wishlist",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        product_id: productId,
        action: "add",
      }),
    },
    { auth: true }
  );

  let body = {};
  try { body = await res.json(); } catch {}

  if (!res.ok) {
    throw new Error(body?.detail || `Failed to update wishlist (${res.status})`);
  }

  return body; // this should be your serialized CollectionItem
}

export async function removeFromWishlist(productId) {
  const res = await apiFetch(
    "collection/wishlist",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        product_id: productId,
        action: "remove",
      }),
    },
    { auth: true }
  );

  let body = {};
  try { body = await res.json(); } catch {}

  if (!res.ok) {
    throw new Error(body?.detail || `Failed to update wishlist (${res.status})`);
  }

  return body; // this should be your serialized CollectionItem
}

export async function verifyUser(uid, token) {
  console.log("Verifying user with uid:", uid, "and token:", token);
  const res = await apiFetch(
    `user/data/verify/${encodeURIComponent(uid)}/${encodeURIComponent(token)}`,
    { method: "GET" },
    { auth: false }
  );
}

export async function getFavouritePokemon() {
  const res = await apiFetch(
    "user/favourite-pokemon",
    { method: "GET" },
    { auth: true }
  );

  let body = {};
  try { body = await res.json(); } catch {}

  if (!res.ok) {
    throw new Error(body?.detail || `Failed to load favourite Pokemon (${res.status})`);
  }

  return body?.slots || [];
}

export async function updateFavouritePokemon(slots) {
  const res = await apiFetch(
    "user/favourite-pokemon",
    {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ slots }),
    },
    { auth: true }
  );

  let body = {};
  try { body = await res.json(); } catch {}

  if (!res.ok) {
    throw new Error(body?.detail || `Failed to update favourite Pokemon (${res.status})`);
  }

  return body;
}

export async function searchCardProductsByName(query, { page = 1 } = {}) {
  const q = String(query || "").trim();
  if (!q) return { items: [], total: 0, page, page_size: 0 };

  const params = new URLSearchParams();
  params.set("page_type", "SINGLE"); // maps to type='CARD' in backend
  params.set("page", String(page));
  params.set("q", q);
  // Avoid substring false-positives (e.g. "mew" matching "mewtwo").
  params.set("match_mode", "word");
  params.set("sort", "id_desc");

  const res = await apiFetch(
    `products/get?${params.toString()}`,
    { method: "GET" },
    { auth: true }
  );

  let body = {};
  try { body = await res.json(); } catch {}

  if (!res.ok) {
    throw new Error(body?.detail || `Failed to search cards (${res.status})`);
  }

  return {
    items: body?.items || [],
    total: body?.total ?? 0,
    page: body?.page ?? page,
    page_size: body?.page_size ?? 0,
  };
}

// Fetch the first matching CARD product, optionally skipping known-bad product ids.
export async function searchFirstCardProductByName(query, { excludeIds = [] } = {}) {
  const q = String(query || "").trim();
  if (!q) return null;

  const excluded = new Set((excludeIds || []).map((id) => Number(id)).filter(Number.isFinite));
  const MAX_PAGES = 5;

  for (let page = 1; page <= MAX_PAGES; page += 1) {
    const params = new URLSearchParams();
    params.set("page_type", "SINGLE"); // maps to type='CARD' in backend
    params.set("page", String(page));
    params.set("page_size", "3");
    params.set("sort", "id_desc");
    params.set("q", q);
    params.set("match_mode", "word");

    const res = await apiFetch(
      `products/get?${params.toString()}`,
      { method: "GET" },
      { auth: true }
    );

    let body = {};
    try { body = await res.json(); } catch {}

    if (!res.ok) {
      throw new Error(body?.detail || `Failed to search cards (${res.status})`);
    }

    const items = (body?.items || []).filter((p) => p?.type === "CARD");
    const match = items.find((p) => !excluded.has(Number(p.id)));
    if (match) return match;

    if (!items.length) break;
    const total = Number(body?.total ?? 0);
    if (total > 0 && page * 3 >= total) break;
  }

  return null;
}